// extracted by mini-css-extract-plugin
export default {"title":"Faq_title__KWorZ","description":"Faq_description__4whzx","question":"Faq_question__MXfvq","answer":"Faq_answer__BO0AP","back":"Faq_back__AyXgD"};